var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 12.75H13.5C10.1863 12.75 7.5 15.4363 7.5 18.75V34.5C7.5 37.8137 10.1863 40.5 13.5 40.5H36.5C38.7091 40.5 40.5 38.7091 40.5 36.5V16.75C40.5 14.5409 38.7091 12.75 36.5 12.75H31.5",
    className: "iconBlue",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.25 32.25C30.0784 32.25 30.75 32.9216 30.75 33.75C30.75 34.5784 30.0784 35.25 29.25 35.25L18.75 35.25C17.9216 35.25 17.25 34.5784 17.25 33.75C17.25 32.9216 17.9216 32.25 18.75 32.25L29.25 32.25Z",
    className: "iconOrangeFill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4142 23.1642C32.1953 22.3832 32.1953 21.1168 31.4142 20.3358C30.6332 19.5547 29.3668 19.5547 28.5858 20.3358L31.4142 23.1642ZM24 27.75L22.5858 29.1642C23.3668 29.9453 24.6332 29.9453 25.4142 29.1642L24 27.75ZM19.4142 20.3358C18.6332 19.5547 17.3668 19.5547 16.5858 20.3358C15.8047 21.1168 15.8047 22.3832 16.5858 23.1642L19.4142 20.3358ZM28.5858 20.3358L22.5858 26.3358L25.4142 29.1642L31.4142 23.1642L28.5858 20.3358ZM25.4142 26.3358L19.4142 20.3358L16.5858 23.1642L22.5858 29.1642L25.4142 26.3358Z",
    className: "iconOrangeFill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 27.75V7.5",
    className: "iconOrange",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/DownloadIcon.b1a7ce653b37b6bec48635406fa28e7f.svg";
export { ForwardRef as ReactComponent };